/**
 * created by lei lei
 * 锁 lock
 * ws 锁适配器
 */
import React, {Component} from 'react';
import {BaseHandler} from "../ws";
import {systemWebsocket} from "../auth";
import {systemBaseEvent} from "../baseEvent";
import {notification} from "antd";

export default class Lock extends BaseHandler {

    constructor({data, callback,showNotification}) {
        super();
        this.data = data;
        this.callback = callback;
        this.showNotification=showNotification
        systemBaseEvent.registerBaseEvent("systemWebsocketOpenAsyncListener", () => {
            this.sendData(this.data);
        });
    }

    type;
    status;
    content;
    loopTime;
    messageId;
    messageData;
    order() {
        return BaseHandler.ORDER_HIGHT - 4;
    }

    isSupport(message) {
        try {
            let data = JSON.parse(message);
            let {type, msg, status, whileTime, id, opration} = data;
            if (opration == 'lock' && (status == 200 || status == 300)) {
                this.status = status;
                this.content = msg;
                this.loopTime = whileTime;
                this.messageId = id;
                this.messageData=data;
                return true;
            }
            return false;
        } catch (e) {
            return false;
        }
    }

    sendData(data) {
        systemWebsocket.send(data);
    }

    handle(msg) {
        if (this.data.id == this.messageId) {
            if (this.status == 200) {
                this.callback && this.callback({...this.messageData,status: true});
                setTimeout(() => {
                    this.sendData(this.data)
                }, this.loopTime)
            } else {
                this.callback && this.callback({...this.messageData,status: false});
                if(this.showNotification){
                    notification.info({
                        message: '系统锁描述',
                        description: this.content,
                        placement: 'topRight',
                        duration: 2,
                    });
                }

            }
        }

    }
}